export default {
    icon: "el-icon-picture",
    title: "图片竖排",
    name: "imageBanner",
    timestamp: 1706343486906001,
    menuConfig: {
        title: "自适应图片宽度显示",
        maxList: 100,
        list: [
            {
                img: "https://img2.baidu.com/it/u=2989817513,2736655585&fm=253&fmt=auto&app=138&f=JPEG?w=1600&h=500",
                info: [
                    {
                        title: "标题",
                        value: "全部商品",
                        tips: "选填，不超过4个字",
                        max: 4
                    },
                    {
                        title: "链接",
                        value: "/pages/goods_cate/goods_cate",
                        tips: "请输入链接",
                        max: 100
                    }
                ]
            }
        ]
    },
    bgStyle: {
        title: "背景样式",
        name: "bgStyle",
        type: 1,
        list: [
            {
                val: "直角",
                icon: "el-icon-edit-outline"
            },
            {
                val: "圆角",
                icon: "el-icon-c-scale-to-original"
            }
        ]
    },
    lrEdge: {
        title: "左右边距",
        val: 10,
        min: 0
    },
    mbConfig: {
        title: "页面间距",
        val: 12,
        min: 0
    },
    id: "id1706343466365000"
}